export default "__VITE_ASSET__BlzfX13p__"